import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref } from "../../../../adapter-vue";
import { isUrl, JSONToObject } from "../../../../utils/index";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import star from "../../../../assets/icon/star-light.png";
import { ICustomMessagePayload } from "../../../../interface";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-custom',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props


const custom = ref();
const message = ref();
const extension = ref();
const isCustom = ref<ICustomMessagePayload>({
  businessID: "",
});

watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  isCustom.value = payload.data || "";
  isCustom.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const openLink = (url: any) => {
  window.open(url);
};

return { __sfc: true,props, custom, message, extension, isCustom, openLink, isUrl, CHAT_MSG_CUSTOM_TYPE, TUITranslateService, Icon, star }
}

})